<template>
  <div class="prosecco-content">
    <div
      class="prosecco-content__background"
      data-in-out
      data-in-out-animation="slide-no-alpha"
      data-in-out-no-menu
      data-in-out-order="1"
      data-out-delay="0.4"
    ></div>

    <div
      class="prosecco-content__image"
      data-in-out
      data-in-out-animation="slide"
      data-in-out-order="2"
      data-in-delay="1"
    >
      <div
        ref="floating"
        class="prosecco-content__image-actual"
        :style="{
          backgroundImage: $route.params.bottle !== 'collezione-leone-prosecco-doc' ? `url('/static/bottles/${content[this.$route.params.bottle] || 'cuvee-1821'}/full.jpg')` : `url('/static/bottles/${content[this.$route.params.bottle] || 'cuvee-1821'}/full-${$store.state.lang}.jpg')`
        }"
      ></div>
    </div>

    <div class="prosecco-content__content">
      <div
        class="prosecco-content__title"
        data-in-out
        data-in-out-animation="stagger-text"
        data-in-out-order="4"
        data-in-delay="0.4"
      >
        <h2 v-html="subtitle"></h2>
        <div v-if="$route.params.bottle === 'cuvee-1821' || $route.params.bottle === 'rose-1821'" class="pininfarina">
          <img src="/static/vector/pininfarina.svg" />
        </div>
      </div>
      <div
        class="prosecco-content__text"
        data-in-out
        data-in-out-animation="slide"
        data-in-out-order="5"
        data-in-delay="0.4"
      >
        <div class="prosecco-content__text-inner" v-html="text"></div>
      </div>
      <a
        v-if="file"
        :href="file.url"
        target="_blank"
        class="prosecco-content__download"
        data-in-out
        data-in-out-animation="slide"
        data-apollo-hover
        data-apollo-hover-animation="scale"
      >
        <div class="prosecco-content__download-pdf">PDF</div>
        <div class="prosecco-content__download-label">Wine Sheet</div>
        <div class="prosecco-content__download-action">
          <ArrowBall />
        </div>
      </a>

      <BlendDetails :data="blendDetails" />
      <WineDetails :data="wineDetails" />
      <Awards :data="awards" v-if="awards && awards.awards.length > 0" />
      <TheOthers />
    </div>

    <MobileFooter />
  </div>
</template>

<script>
import Medusa from '@adoratorio/medusa';
import TweenMax from 'gsap/TweenMaxBase';
import engine from '@/scripts/engine';
import scroll from '@/scripts/scroll';
import medusa from '@/scripts/medusa';
import animations from '@/assets/animations';
import BlendDetails from '@/components/prosecco/BlendDetails.vue';
import WineDetails from '@/components/prosecco/WineDetails.vue';
import Awards from '@/components/prosecco/Awards.vue';
import TheOthers from '@/components/prosecco/TheOthers.vue';
import ArrowBall from '@/components/ArrowBall.vue';
import MobileFooter from '@/components/MobileFooter.vue';
import { SplitText } from '@/scripts/libs/SplitText';
import { getComponent } from '../../scripts/utils';

export default {
  name: 'ProseccoContent',

  props: ['data'],

  components: {
    BlendDetails,
    WineDetails,
    Awards,
    TheOthers,
    ArrowBall,
    MobileFooter,
  },

  data() {
    return {
      content: {
        'cuvee-1821': 'cuvee-1821',
        'prestige-1821': 'prestige-1821',
        'rose-1821': 'rose-1821',
        'special-cuvee-millesimato': 'special-cuvee-millesimato',
        'collezione-leone-prosecco-doc': 'collezione-leone-prosecco-doc',
        'collezione-leone-prosecco-doc-rose': 'collezione-leone-prosecco-doc-rose',
      },
    };
  },

  computed: {
    subtitle() {
      return getComponent(this.data, 'AppText').column[0].title;
    },

    text() {
      return getComponent(this.data, 'AppText').column[0].text;
    },

    file() {
      const c = getComponent(this.data, 'Download');
      return c ? c.file : false;
    },

    blendDetails() {
      return getComponent(this.data, 'BlendDetails');
    },

    wineDetails() {
      return getComponent(this.data, 'WineDetails');
    },

    awards() {
      return getComponent(this.data, 'Awards');
    },
  },

  mounted() {
    engine.add(this.scroll, 'prosecco-scroll');
    this.$nextTick(() => {
      const nodes = Array.from(this.$el.querySelectorAll('[data-medusa]'));
      nodes.forEach((node) => {
        animations.get(`${node.dataset.medusaAnimation}-initial`)(node);
      });
      medusa.ref.addTarget({
        id: 'medusa-prosecco',
        container: document,
        nodes,
        callback: this.medusa,
        mode: Medusa.MODE.ONCE,
        threshold: 0.0,
        offsets: '0px 0px -200px 0px',
      });
    });
    this.$nextTick(() => {
      scroll.ref.scrollTo({ x: 0, y: 0 }, 0);
      scroll.setBoundries(this.$el);
    });
    new SplitText(this.$el.querySelector('h2'), { charsClass: 'stagger-element' }); // eslint-disable-line
  },

  methods: {
    scroll() {
      scroll.checkIsScrolled();
      this.$el.style.transform = `translateY(-${scroll.ref.amount.y}px)`;
      const hero = document.querySelector('.prosecco-hero');
      if (hero) hero.style.transform = `translateY(-${scroll.ref.amount.y}px)`;

      const image = this.$refs.floating;
      const center = window.innerHeight / 2;
      const fromCenter = (image.getBoundingClientRect().top + image.getBoundingClientRect().height / 2) - center;
      TweenMax.set(image, { y: fromCenter * 0.4, rotation: fromCenter * 0.005 });
    },
    medusa(target) {
      animations.get(`${target.target.dataset.medusaAnimation}-in`)(target.target).play();
    },
  },

  beforeDestroy() {
    engine.remove('prosecco-scroll');
    medusa.ref.removeTarget('medusa-prosecco');
    this.$store.commit('SET_PAGE_SCROLLED', false);
  },
};
</script>

<style lang="scss" scoped>
.prosecco-content {
  width: 100%;

  &__background {
    @extend %full;
    background-color: $color-black;
  }

  &__image {
    position: absolute;
    top: calc((100vh / 18) * -1);
    width: calc(719px * var(--rw));
    height: calc(1618px * var(--rw));
    right: calc((100vw / 32) * 3);

    &-actual {
      @extend %full;
      background-image: url('/static/img/01.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }
  }

  &__content {
    position: relative;
    padding-top: calc(((100vh / 18) * 7) + (320px * var(--rw)));
    left: calc((100vw / 32) * 7);

    @include mq($until: ds) {
      left: calc((100vw /32) * 4);
    }

    h2 {
      font-family: 'IGT Frankling Gothic';
      font-size: rem(200px);
      font-size: calc(200px * var(--rw));
      font-weight: normal;
      line-height: 1;
      text-transform: uppercase;

      @include mq($until: ds) {
        font-size: rem(180px);
        font-size: calc(180px * var(--rw));
      }

      @include mq($until: ipadP) {
        font-size: rem(70px);
        font-size: calc(70px * var(--rw));
      }
    }
  }

  &__text {
    position: relative;
    width: calc((100vw / 32) * 8);
    color: $color-white;
    margin-top: 100px;

    &-inner p {
      font-size: rem(22px);
      font-size: $font-size-text;
      line-height: 1.8em;
    }

    @include mq($until: ipadL) {
      width: calc(100% - ((100vw / 32) * 8));
    }
  }

  &__download {
    position: relative;
    width: calc((100vw / 32) * 6);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 80px;
    color: $color-white;
    cursor: pointer;

    @include mq($until: ipadL) {
      width: calc((100vw / 32) * 12);
    }

    @include mq($until: ipadP) {
      width: 100%;
    }

    &::after {
      content: ' ';
      position: absolute;
      bottom: 0px;
      width: 65%;
      height: 1px;
      background-color: $color-white;
      opacity: 0.2;
    }

    &-pdf {
      font-family: 'IGT Frankling Gothic';
      font-weight: bold;
    }

    &-label {
      font-size: rem(22px);
      font-size: $font-size-text;
      font-weight: 300;
    }

    &-action {
      width: calc(70px * var(--rw));
      height: calc(70px * var(--rw));
      opacity: 0.6;
    }

    &:hover ::v-deep svg circle {
      transform: scale(1);

      &.fill {
        stroke-dashoffset: 0;
        transition: transform .3s $inOutCubic,
                    stroke-dashoffset .3s $inOutCubic .2s;
      }
    }

    &::v-deep .arrow-rotation {
      transform: rotate(90deg);
    }

    &::v-deep svg circle {
      transform-origin: 50% 50%;
    }

    &:hover ::v-deep .arrow {
      transition: opacity .3s $inOutCubic .2s;
      opacity: 1;

      .arrow-animation {
        animation-name: arrow-loop;
        animation-duration: .8s;
        animation-delay: .3s;
        animation-iteration-count: 1;
        animation-timing-function: $inOutCubic;
      }
    }
  }

  .pininfarina {
    filter: brightness(200);

    img {
      margin-left: 10px;
      margin-right: auto;

      @include mq($until: ipadP) {
        width: 60%;
        margin-top: 20px;
      }
    }
  }
}
</style>
